/**
 * Created by xixue on 2018/9/30.
 */
const rootUrl = window.location.host
let socketHost = ''
let qmsocketHost = ''
let requestHost = ''
let qmRequestHost = ''
let teacherHost = ''
let Env = ''
let logHost = ''

switch (rootUrl) {
    case 'mmath.classba.cn':
    case 'mmath.171xue.com':
    case 'supervise-v3.classba.cn':
    case 'me.classba.cn':
    case 'supervise.classba.cn':
        socketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'socket.classba.cn'
        qmsocketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'qmsocket.classba.cn'
        requestHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'supervise-api.classba.cn'
        qmRequestHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'qmsupervise-api.classba.cn'
        teacherHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'teacher.classba.cn'
        Env = 'prod'
        break
    case 'supervise-v3-pre.classba.cn':
    case 'supervise-pre.classba.cn':
        socketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'socket-pre.classba.cn'
        qmsocketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'qmsocket-pre.classba.cn'
        requestHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'supervise-api-pre.classba.cn'
        qmRequestHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'qmsupervise-api-pre.classba.cn'
        teacherHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'teacher-pre.classba.cn'
        Env = 'pre'
        break
    case 'supervise.fe.dev.myyixue.com':
        socketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'socket.be.dev.myyixue.com'
        requestHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'supervise.be.dev.myyixue.com'
        teacherHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'teacher.fe.dev.myyixue.com'
        Env = 'dev'
        break
    default:
        socketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'test-socket.classba.cn'
        qmsocketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'qmsocket-test.classba.cn'
        requestHost = (window.location.protocol === 'https:' ? 'https://' : 'https://') + 'supervise-api-test.classba.cn'
        qmRequestHost = (window.location.protocol === 'https:' ? 'https://' : 'https://') + 'qmsupervise-api-test.classba.cn'
        // requestHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'teacher-api.be.dev.myyixue.com'
        teacherHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'teacher-test.classba.cn'
        Env = 'test'
}
const publicBusyUrl = `https://statics.classba.cn/${Env}/fe_public/public/busyLineUp/currentLimiting.html`
export { socketHost, qmsocketHost, requestHost, qmRequestHost, publicBusyUrl,teacherHost, logHost }



// WEBPACK FOOTER //
// ./src/utils/hostsconfig.js